import { render, staticRenderFns } from "./InventoryConsume.vue?vue&type=template&id=b3c98186&scoped=true"
import script from "./InventoryConsume.vue?vue&type=script&lang=js"
export * from "./InventoryConsume.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3c98186",
  null
  
)

export default component.exports